{{#each images}}
    <div class="thumbnail metadata-thumbnail" data-screenshot-index="{{@index}}">
        <img src="{{#if this.attributes.src}}{{#ifNotEqual (getPreviewUrl this.attributes.src) '//:0'}}{{ getPreviewUrl this.attributes.src }}{{/ifNotEqual}}{{/if}}" />
        <div class="caption">
            <button type="button" class="btn btn-block btn-primary choose-screenshot-button">{{t "editor.inspector.properties.image.chooseButton"}}</button>
            <button type="button" class="btn btn-block btn-danger remove-screenshot-button">{{t "metadata.delete"}}</button>
        </div>
    </div>
{{/each}}
